import React from "react";
 // Custom CSS for styling
import "../pages/common.css"
const NumbersSection = () => {
  const stats = [
    {
      icon: "./images/icon1.png", // Replace with actual icon image path
      number: "100,000+",
      title: "#LivspaceHomes",
    },
    {
      icon: "./images/icon2.png", // Replace with actual icon image path
      number: "3,500+",
      title: "expert designers",
    },
    {
      icon: "./images/icon3.png", // Replace with actual icon image path
      number: "3 countries",
      title: "60+ cities",
    },
  ];

  return (
    <section className="bg2">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="wrapper">
                <h2>Why Integrated Interior?</h2>

                <ul className="listdot">
                  <li>Custom Designs</li>
                  <li>Experienced Team</li>
                  <li>High-Quality Materials</li>
                  <li>Timely Delivery</li>
                  <li>Customer-Centric Approach</li>
                </ul>
               
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-6">
              <div className="img-wrapper">
                <img src="/images/team.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default NumbersSection;
